import { PaperClipIcon } from "@heroicons/react/24/outline";

export default function BlocDocuments({ data }) {
  return (
    <section className="space-y-6 bg-white p-6 rounded-xl shadow">
      <h2 className="text-xl font-bold text-gray-800">Documents & Justificatifs</h2>

      {data?.documents?.length > 0 ? (
        <ul className="divide-y divide-gray-200">
          {data.documents.map((doc, index) => (
            <li key={index} className="flex items-center justify-between py-3">
              <div className="flex items-center gap-3">
                <PaperClipIcon className="w-5 h-5 text-gray-500" />
                <div>
                  <p className="text-sm font-medium text-gray-800">{doc.nom}</p>
                  {doc.dateAjout && (
                    <p className="text-xs text-gray-500">
                      Ajouté le {new Date(doc.dateAjout).toLocaleDateString()}
                    </p>
                  )}
                </div>
              </div>
              {doc.url && (
                <a
                  href={doc.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-blue-600 hover:underline"
                >
                  Télécharger
                </a>
              )}
            </li>
          ))}
        </ul>
      ) : (
        <p className="text-sm text-gray-500">Aucun document enregistré pour cette société.</p>
      )}
    </section>
  );
}
